import type { Components } from "@mui/material";

export const MuiListSubheader: Components["MuiListSubheader"] = {
  styleOverrides: {
    root: {
      fontWeight: 700,
    },
  },
};
